import { ActionReducerMap } from '@ngrx/store';

import { GridReducers, ListReducers } from '@core/services';
import { AppState } from '@core/state/interfaces';

import { AdminReducers } from '@admin/state';
import { AuthReducers } from '@auth/state';
import { InventoryReducers } from '@inventory/state';
import { ItemReducers } from '@item/state';
import { OrderReducers } from '@order/state';
import { ReportReducers } from '@report/state';

export const reducers: ActionReducerMap<AppState> = {
  admin: AdminReducers.reducer,
  auth: AuthReducers.reducer,
  grid: GridReducers.reducer,
  inventory: InventoryReducers.reducer,
  list: ListReducers.reducer,
  order: OrderReducers.reducer,
  report: ReportReducers.reducer,
  item: ItemReducers.reducer,
};
